const formStyle = {
  m: 1,
  minWidth: 120,
};

export { formStyle };
